// src/services/pixel.service.js
import axios from 'axios';
import { auth } from './firebase';

const api = axios.create({
  baseURL: '/api',
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class PixelService {
  static async getPixels(params = {}) {
    try {
      // If specific IDs are provided, fetch them individually
      if (params.connectedPixels && Array.isArray(params.connectedPixels)) {
        const pixelPromises = params.connectedPixels.map((id) =>
          api.get(`/pixels/${id}`).then((response) => response.data),
        );

        const pixels = await Promise.all(pixelPromises);
        return {
          pixels,
          total: pixels.length,
          page: 1,
          pageSize: pixels.length,
          totalPages: 1,
        };
      }

      // Otherwise, use the search endpoint
      const response = await api.get('/pixels', {
        params: {
          search: params.search,
          page: params.page,
          limit: params.limit,
          status: params.status,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching pixels:', error);
      throw error;
    }
  }

  static async getPixel(id) {
    try {
      const response = await api.get(`/pixels/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching pixel ${id}:`, error);
      throw error;
    }
  }

  static async createPixel() {
    try {
      const response = await api.post('/pixels');
      return response.data;
    } catch (error) {
      console.error('Error creating pixel:', error);
      throw error;
    }
  }
}
